"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRowCount = getRowCount;
exports.getColSpan = getColSpan;
exports.getRowSpan = getRowSpan;
exports.getCurrentRowCols = getCurrentRowCols;
exports.getMergedCols = getMergedCols;

var _lib = require("../../lib");

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function getRowCount(columns) {
  var defaultCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return columns.reduce(function (max, item) {
    var count = defaultCount;

    if ((0, _lib.arrayHasItems)(item.columns)) {
      count += getRowCount(item.columns, count);
    }

    return count > max ? count : max;
  }, 1);
}

function getColSpan(columns) {
  var defaultSpan = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  if ((0, _lib.arrayHasItems)(columns)) {
    return columns.reduce(function (colSpan, item) {
      var span = defaultSpan;

      if ((0, _lib.arrayHasItems)(item.columns)) {
        span = getColSpan(item.columns, span);
      }

      return colSpan + span;
    }, 0);
  }

  return defaultSpan;
}

function getRowSpan(item, row, rowIdx, currentRow) {
  var defaultSpan = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
  var span = defaultSpan;

  if (currentRow <= row && currentRow !== rowIdx) {
    if ((0, _lib.arrayHasItems)(item.columns)) {
      span = getRowSpan(item.columns, row, rowIdx, currentRow, span);
    }
  }

  if (currentRow === rowIdx) {
    if (rowIdx !== row - 1) {
      if (!(0, _lib.arrayHasItems)(item.columns)) {
        span = rowIdx > 0 ? row - span : row;
      }
    }
  }

  return span;
} // get columns for current row


function getCurrentRowCols(key, row, rowIdx, columns) {
  var currentRow = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  return columns.reduce(function (arr, item) {
    var cols = [];
    var colSpan = getColSpan(item.columns);
    var rowSpan = getRowSpan(item, row, rowIdx, currentRow);
    var propKey = "".concat(key, "Props");

    if (currentRow <= row && currentRow !== rowIdx) {
      if ((0, _lib.arrayHasItems)(item.columns)) {
        cols = getCurrentRowCols(key, row, rowIdx, item.columns, currentRow + 1);
      } else {
        var props = {
          colSpan: colSpan,
          rowSpan: rowSpan,
          isEmpty: true
        };
        cols.push(_defineProperty({}, propKey, _objectSpread({}, props, item[propKey])));
      }
    }

    if (cols && (0, _lib.numberHasLength)(cols.length)) {
      return arr.concat(cols);
    }

    if (currentRow === rowIdx) {
      var _props = {
        colSpan: colSpan,
        rowSpan: rowSpan,
        isEmpty: !item[key]
      };
      arr.push(Object.assign({}, item, _defineProperty({}, propKey, _objectSpread({}, _props, item[propKey]))));
    }

    return arr;
  }, []);
}

function getMergedCols(key, columns) {
  var renderColSpan = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return columns.reduce(function (data, item, idx, arr) {
    var result = data.result;
    var colSpan = data.colSpan;
    var propKey = "".concat(key, "Props");
    var props = item[propKey];

    if (props && props.isEmpty) {
      colSpan += props.colSpan || 1;
      var newCol = Object.assign({}, item, _defineProperty({}, propKey, _objectSpread({}, props, {
        colSpan: colSpan
      })));

      if (idx + 1 < arr.length) {
        var nextItem = arr[idx + 1];
        var nextItemKeyProps = nextItem[propKey];

        if (nextItemKeyProps && !nextItemKeyProps.isEmpty) {
          if (props.rowSpan > 0 || renderColSpan) {
            result.push(newCol);
            colSpan = 0;
          }
        }
      } else if (props.rowSpan > 0 || renderColSpan) {
        result.push(newCol);
        colSpan = 0;
      }
    } else {
      result.push(item);
    }

    if (idx === arr.length - 1) {
      // return arr at the end
      return result;
    }

    return {
      result: result,
      colSpan: colSpan
    };
  }, {
    result: [],
    colSpan: 0
  });
}